// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__16pbU","importantInfo":"styles_importantInfo__2_YdY"};